import { actionTypeSuccessShowAppReview } from './shared/helper/appReview';
import { combineReducers } from 'redux';
import { reviewDialog } from 'platformImpl';
import app from './painel/reducer';
import artigo29 from './apps/artigo29/reducer';
import autenticidade from './apps/autenticidade/reducer';
import avaliacao from './apps/avaliacao/reducer';
import beneficio from './apps/beneficio/reducer';
import biometria from './apps/biometria/reducer';
import calendarioPagamento from './apps/calendarioPagamento/reducer';
import captcha from './apps/captcha/reducer';
import carteira from './apps/carteira/reducer';
import cat from './apps/cat/reducer';
import certificadoDeficiencia from './apps/certificadoDeficiencia/reducer';
import chatbot from './apps/chatbot/reducer';
import cism from './apps/contribuicaoInferior/reducer';
import concal from './apps/concal/reducer';
import config from './apps/config/reducer';
import crer from './apps/crer/reducer';
import ctc from './apps/certidaoTempoContribuicao/reducer';
import dadosCadastrais from './apps/dadosCadastrais/reducer';
import declaracaoAtividade from './apps/declaracaoAtividade/reducer';
import declaracaoPpp from './apps/declaracaoPpp/reducer';
import drawerPDF from './shared/template/drawerPDF/reducer';
import drsci from './apps/drsci/reducer';
import eco from './apps/eco/reducer';
import entidadesAssociativas from './apps/bloqDesbloqMensalidade/reducer';
import extratoBenefico from './apps/extratoBeneficio/reducer';
import extratoCnis from './apps/extratoPrevidenciario/reducer';
import extratoConsignado from './apps/extratoConsignado/reducer';
import extratoIR from './apps/extratoIR/reducer';
import hiscre from './apps/hiscre/reducer';
import laudosMedicos from './apps/laudosMedicos/reducer';
import localizadorAps from './apps/localizadorAPS/reducer';
import nadaconsta from './apps/nadaConsta/reducer';
import notificacoes from './apps/notificacao/reducer';
import pedidoRecomendado from './apps/novopedido/reducer';
import pispasepfgts from './apps/pisPasepFgts/reducer';
import provaVida from './apps/provaVida/reducer';
import requerimentos from './apps/requerimentos/reducer';
import revisao from './apps/revisao/reducer';
import seguradoEspecialReducer from './apps/requerimentos/seguradoEspecial/reducer';
import servicos from './apps/servicos/reducer';
import session from './login/reducer';
import simulacao from './apps/simulador/reducer';
import taxasJuros from './apps/taxasJuros/reducer';
import servicoNaoHabilidado from './apps/servicoNaoHabilitado/reducer';
import buscarServico from './painel/component/buscarServico/reducer';
import consultarDescontosEntidadesAssociativas from './apps/entidadesAssociativas/consultarDescontos/reducer';
import { isRotaAberta } from 'login/helper';
import feedback from './painel/component/feedback/reducer';

const appReducer = combineReducers({
    app,
    artigo29,
    autenticidade,
    avaliacao,
    beneficio,
    biometria,
    buscarServico,
    calendarioPagamento,
    captcha,
    carteira,
    cat,
    certificadoDeficiencia,
    chatbot,
    cism,
    concal,
    config,
    crer,
    ctc,
    dadosCadastrais,
    declaracaoAtividade,
    declaracaoPpp,
    drawerPDF,
    drsci,
    eco,
    entidadesAssociativas,
    extratoBenefico,
    extratoCnis,
    extratoConsignado,
    extratoIR,
    hiscre,
    laudosMedicos,
    localizadorAps,
    nadaconsta,
    notificacoes,
    pedidoRecomendado,
    pispasepfgts,
    provaVida,
    requerimentos,
    revisao,
    seguradoEspecialReducer,
    servicos,
    session,
    simulacao,
    taxasJuros,
    servicoNaoHabilidado,
    consultarDescontosEntidadesAssociativas,
    feedback
});

const rootReducer = (state, action) => {
    let rotaAberta = isRotaAberta(window.location.hash);
    if (action.type === 'USUARIO_DESLOGADO' && !rotaAberta) {
        localStorage.removeItem('ifs_auth');
        localStorage.removeItem('ifs_ts');
        sessionStorage.removeItem('initTrack');
        localStorage.removeItem('dicionarioPaths');
        localStorage.removeItem("refreshPedidos");
        localStorage.removeItem('breadcrumbV35');

    }

    //Verifica se 'action.type' para execução dos serviços está mapeada para poder solicitar 
    //que o usuário possa avaliar o App. 
    if(actionTypeSuccessShowAppReview(action.type)){
        setTimeout(()=> { reviewDialog() }, 5000);
    }

    return appReducer(state, action)
};

export default rootReducer;
